import React from 'react';

const UnderConstruction = () => {
    return (
        <div className='min-h-screen flex items-center justify-center'>
            <img src="https://i.ibb.co/hy32sCX/construction-8.webp" alt="" />
        </div>
    );
};

export default UnderConstruction;